import { LoadingOutlined, SearchOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Col, Input, Row, Spin, Table } from 'antd';
import Column from 'antd/es/table/Column';
import { NhanVien_MucLuong_PhuCap } from '../../models/luong/Luong';

const DanhSachMucLuongVaPhuCapTheoNhanVienTableModal = ({ data, checklist, hide, onChange, onChangeCheckAll }: { data: Array<NhanVien_MucLuong_PhuCap>, checklist: Array<NhanVien_MucLuong_PhuCap>, hide: () => void, onChange: (data: any, e: any) => void, onChangeCheckAll: (e: boolean) => void }) => {    
    const [loading, setLoading] = useState(false);
    const [checkAll, setCheckAll] = useState(false);
    const [searchText, setSearchText] = useState('');
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin rev={undefined} />;    

    return (
        <section>
            <Modal show={true} onHide={hide} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Danh sách nhân viên</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ?
                        <div className='text-center'><Spin indicator={antIcon} /></div> :
                        <>
                            <Row className="form-group">
                                <Col span={12}>
                                    <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên nhân viên để tìm kiếm..." onChange={(e) => setSearchText(e.target.value)} />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Table
                                        locale={{ emptyText: "Không có dữ liệu" }}
                                        dataSource={data.map((item: any, index) => { item.key = index; return item; }).filter((record: NhanVien_MucLuong_PhuCap) =>
                                            record.hoTen.toLowerCase().includes(searchText.toLowerCase())
                                        )}
                                        pagination={false}
                                    >
                                        <Column
                                            title="STT"
                                            key="STT"
                                            render={(value, record, index) =>
                                            (
                                                <>
                                                    {index + 1}
                                                </>
                                            )
                                            }
                                        />
                                        <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                                        <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" />
                                        <Column title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" />
                                        <Column
                                            title={
                                                <input
                                                    type="checkbox"
                                                    checked={checkAll}
                                                    onChange={(e) => {
                                                        setCheckAll(e.target.checked);
                                                        onChangeCheckAll(e.target.checked)
                                                    }}
                                                />
                                            }
                                            key="choose"
                                            render={(value: NhanVien_MucLuong_PhuCap, record, index) =>
                                            (
                                                <div className='text-center' key={value.idNhanVien}>
                                                    <input type="checkbox"
                                                        data-index={value?.idNhanVien}
                                                        checked={checklist.map(x => x.idNhanVien).includes(value?.idNhanVien) ? true : false}
                                                        onChange={(e) => {
                                                            onChange({
                                                                "hoTen": value.hoTen,
                                                                "idNhanVien": value.idNhanVien,
                                                                "idChucVu": value.idChucVu,
                                                                "tenChucVu": value.tenChucVu,
                                                                "idDonVi": value.idDonVi,
                                                                "tenDonVi": value.tenDonVi,
                                                                "idNhom": value.idNhom,
                                                                "tenNhom": value.tenNhom,
                                                                "mucLuongBHXH": value.mucLuongBHXH,
                                                                "phuCapChucVu": value.phuCapChucVu,
                                                                "mucThuNhap": 0,
                                                                "maNhanVien": value.maNhanVien
                                                            }, e.target.checked)
                                                        }}
                                                    />
                                                </div>
                                            )
                                            }
                                        />
                                    </Table>
                                </Col>
                            </Row>
                        </>
                    }
                </Modal.Body>
            </Modal >
        </section>
    );
};
export default DanhSachMucLuongVaPhuCapTheoNhanVienTableModal;
